import { Helmet } from "react-helmet-async";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ProjectGalleryGrid } from "@/components/ProjectGalleryGrid";
import { GallerySection } from "@/components/GallerySection";
import { VideoPortfolioSection } from "@/components/VideoPortfolioSection";

export default function Gallery() {
  return (
    <>
      <Helmet>
        <title>Project Gallery Totowa, NJ | Masonry Pro Construction</title>
        <meta name="description" content="Before-and-after photos of paver patios, retaining walls, driveways, and stone work from Masonry Pro Construction, serving Totowa and North Jersey homes." />
        <meta property="og:description" content="Before-and-after photos of paver patios, retaining walls, driveways, and stone work from Masonry Pro Construction, serving Totowa and North Jersey homes." />
        <meta property="og:title" content="Project Gallery Totowa, NJ | Masonry Pro Construction" />
        <meta
          property="og:description"
          content="See our work in action: project photos and videos from across North New Jersey. Retaining walls, paver patios, driveways, stone veneer, and outdoor living."
        />
        <meta property="og:image" content="https://masonry-pro.com/og/paver-patios.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:type" content="image/jpeg" />
      </Helmet>

      <Header />

      <main className="min-h-screen bg-background">
        {/* Page hero */}
        <section className="pt-32 pb-6 md:pt-40 md:pb-8">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
              Our Project Gallery: <span className="text-gradient-gold">Totowa, NJ</span> and North Jersey Craftsmanship
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Transformations and project videos from homeowners across North New Jersey.
            </p>
          </div>
        </section>

        {/* Finished Projects Grid */}
        <ProjectGalleryGrid />

        {/* Before & After Photo Carousel */}
        <GallerySection />

        {/* YouTube Video Portfolio */}
        <VideoPortfolioSection />
      </main>

      <Footer />
    </>
  );
}
